import React from 'react';
import './ScoreBar.scss';

export default function ScoreBar(props) {
    const minScore = props.minScore;
    const maxScore = props.maxScore;
    const score = props.score;
    const scoreRange = maxScore - minScore;
    const rangeComparator = props.isMobile ? 5 : 10; // Minimal range that will have 10px width
    const rangeDelta = rangeComparator - scoreRange;
    let overallScoreModifier = 0; // Need for case, when $maxRating + $ratingRightAddition > 100
    let ratingLeftAddition = 0; //This variable shows how much % we need to add to the left to achieve 10px width of the range
    let ratingRightAddition = 0; //This variable shows how much % we need to add to the right to achieve 10px width of the range
    let leftPosition;
    let rightPosition;

    if(scoreRange > 0 && rangeDelta > 0) {
        const leftDelta = score - minScore;
        const rightDelta = maxScore - score;

        ratingLeftAddition = rightDelta ? rangeDelta * leftDelta / rightDelta : rangeDelta;
        ratingRightAddition = leftDelta ? rangeDelta * rightDelta / leftDelta : rangeDelta;

        if(maxScore + ratingRightAddition > 100) {
            overallScoreModifier = ratingRightAddition;
            ratingLeftAddition = ratingRightAddition;
            ratingRightAddition = 0;
        }
    }

    leftPosition = 100 - minScore + ratingLeftAddition;
    rightPosition = maxScore + ratingRightAddition;
    let barMarkShift = 0;
    let barMarkPosition;
    let rangeNumbers;
    let leftMarkPosition;
    let rightMarkPosition;

    if( score === 100 ) {
        barMarkShift = props.isMobile ? 4 : 1;
    } else {
        barMarkShift = props.isMobile ? -1 : -2;
    }

    barMarkPosition = {left: `calc(${score - overallScoreModifier}% - ${barMarkShift}px)`};

    if(score < 4 && !props.isMobile) {
        barMarkPosition = {left: '5px'};
    }

    if(props.isOneModelRated) {
        if(props.isMobile) {
            rangeNumbers = (
                <p className="overall-score__range__text">
                    1 Model Rated
                </p>
            );
        } else {
            const isLeft = leftPosition < 50;
            const rangeMarkClass = isLeft ? 'overall-score__range__min' : 'overall-score__range__max';
            const positionStyle = isLeft ? {right: `calc(${100 - rightPosition}% - 3px)`} : {left: `calc(${100 - leftPosition}% + 2px)`};

            rangeNumbers = (
                <span className={rangeMarkClass} style={positionStyle}>
                    1 Model Rated
                </span>
            );
        }

        rightPosition = 100;
    } else {
        let rightMarkClass = 'overall-score__range__max';
        leftMarkPosition = {right: `calc(${leftPosition}% - 1px)`};

        if(props.isMobile && maxScore + ratingRightAddition > 90) {
            rightMarkClass = 'overall-score__range__min';
            rightMarkPosition = {right: `${100 - rightPosition}%`}
        } else {
            rightMarkClass = 'overall-score__range__max';
            rightMarkPosition = {left: `calc(${rightPosition}% - ${maxScore > 90 ? 1 : 0}px)`}
        }

        rangeNumbers = (
            <div>
                <span className="overall-score__range__min" style={leftMarkPosition}>
                    {minScore}
                </span>
                <span className={rightMarkClass} style={rightMarkPosition}>
                    {maxScore}
                </span>
            </div>
        );
    }

    return (
    <div className="overall-score__bar">
        <div className="overall-score__bar__progress">
            <div
                className="overall-score__bar__progress__range"
                style={{left: `${100 - leftPosition}%`, right: `${100 - rightPosition}%`}}
            />
            <span
                className={`overall-score__bar__mark ${props.type}`}
                style={barMarkPosition}
            />
        </div>
        {rangeNumbers}
    </div>
    );
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/OverallScore/ScoreBar.jsx